import React, { useContext, useEffect, useState } from 'react'
import { AdvertTeaserEntry, Platform } from '../helper/interfaces';
import { getContentAd, getRessortAd } from './Ad';
import { TeaserData } from './teaser'
import Script from 'next/script'
import { AppContext } from '../provider/AppContextProvider';
import { ConsentContext } from '../provider/ConsentContextProvider';
import { CmpIdentifier } from '../helper/enums';

export default function TeaserAd(data: TeaserData) {
  const { appInfo, isAllowedByCmp } = React.useContext(AppContext);
  const [widgetId, setWidgetId] = useState<string | null>(null);
  const [installationKey, setInstallationKey] = useState<string | null>(null);
  const teaser = data.teaser as AdvertTeaserEntry;
  const showAd = process.env.NEXT_PUBLIC_SHOW_ADS === "true"
  
  const isOutbrainRecoAd =  teaser.adType == "outbrainRecoAd"
  const { getProviderId } = useContext(ConsentContext);
  const cmpVendorId = getProviderId(CmpIdentifier.Outbrain);
  const isOutbrainAllowed = cmpVendorId && isAllowedByCmp(cmpVendorId)

  useEffect(() => {
    if(appInfo.platform === Platform.iOS || window?.startInAppPurchase instanceof Function) {
      setWidgetId(process.env.NEXT_PUBLIC_OUTBRAIN_RECO_AD_WIDGET_ID_IOS ?? '')
      setInstallationKey(process.env.NEXT_PUBLIC_OUTBRAIN_RECO_AD_INSTALLATION_ID_IOS ?? '')
    } else {
      setWidgetId(process.env.NEXT_PUBLIC_OUTBRAIN_RECO_AD_WIDGET_ID_ANDROID ?? '')
      setInstallationKey(process.env.NEXT_PUBLIC_OUTBRAIN_RECO_AD_INSTALLATION_ID_ANDROID ?? '')
    }
  }, [appInfo])
  
  return (
    <React.Fragment>
      {showAd && !isOutbrainRecoAd && teaser.ads && getRessortAd(teaser.ads)
      }
       {showAd && !isOutbrainRecoAd && !teaser.ads && getContentAd(teaser.position)
      }
      {showAd && isOutbrainRecoAd && widgetId && isOutbrainAllowed &&
      <>
      <div className="OUTBRAIN" data-src={process.env.NEXT_PUBLIC_BACKEND_URL} data-widget-id={widgetId} id="outbrain_widget_0"></div>
      <Script key="outbrain" id="outbrain" async src="https://widgets.outbrain.com/outbrain.js"></Script>
      </>
      }
    </React.Fragment>
  )
}